import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { FormGroup, Input, Row, Col, Button } from "reactstrap";

// helpers
import { showMessage } from "../../../helpers/message";
import { formateDateApi } from "../../../helpers/formats";

// api
import analiseboletim_api from "../../../api/analiseboletim_api.js";


export default function PublicacaoDiarioOficial({ boletimVistoria, setshowLoading, handleReturn }) {

    const { register, getValues } = useForm({ mode: "onBlur" });

    const handleExecutarAcao = (acao) => {
        let data = getValues();

        if (data.numeroProcesso == "" || data.dataPublicacao == "") {
            showMessage("Aviso", "Informe o número do processo e a data de publicação", 'error', null);
            return;
        }

        let json_submit = {
            boletimVistoria_Id: boletimVistoria.boletimVistoria_Id,
            situacaoAnalise: boletimVistoria.situacaoAnalise,
            acao: acao,
            observacao: data.observacao,
            publicacaoBoletim: {
                dataPublicacao: formateDateApi(data.dataPublicacao),
                numeroProcesso: data.numeroProcesso
            }
        }

        setshowLoading(true);
        analiseboletim_api.post(json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { handleReturn(true) });
            }
        })

    }

    return (
        <>
            <h5 className="subtitleCardInfo">Publicação no Diário Oficial</h5>
            <Row className="mb-4">
                <Col lg="12" md="12" sm="12">
                    <FormGroup>
                        <label className="form-control-label">Observações</label>
                        <Input className="form-control"
                            autocomplete="off"
                            type="text"
                            name="observacao"
                            innerRef={register({ required: false })}
                        />
                    </FormGroup>
                </Col>
                <Col lg="6" md="6" sm="12">
                    <FormGroup>
                        <label className="form-control-label">Data da Publicação</label>
                        <Input className="form-control"
                            autocomplete="off"
                            type="date"
                            name="dataPublicacao"
                            innerRef={register({ required: false })}
                        />
                    </FormGroup>
                </Col>
                <Col lg="6" md="6" sm="12">
                    <FormGroup>
                        <label className="form-control-label">Número Processo SEI</label>
                        <Input className="form-control"
                            autocomplete="off"
                            type="text"
                            name="numeroProcesso"
                            innerRef={register({ required: false })}
                        />
                    </FormGroup>
                </Col>
                <Col lg="12" md="12" sm="12">
                    <Button color="warning" onClick={() => handleExecutarAcao("Publicar Diário Oficial (Advertência)")}>
                        Publicar e Aplicar Advertência
                    </Button>
                    <Button color="danger" onClick={() => handleExecutarAcao("Publicar Diário Oficial (Multa)")}>
                        Publicar e Aplicar Multa
                    </Button>
                </Col>
            </Row>
        </>
    );
}
